<script>
import SearchProfessionals from "./Steps/SearchProfessionals";
import Professionals from "./Steps/Professionals";
import DatePicker from "@/components/_Shared/DatePicker";
import EventsAvailable from "./Steps/EventsAvailable";
import TimePicker from "@/components/_Shared/TimePicker";
import ConfirmPeriodAndPrice from "./Steps/ConfirmPeriodAndPrice";

import scrollToMixin from "@/mixins/scrollToMixin";
import timeMixin from "@/mixins/timeMixin";

import { mapState, mapActions } from "vuex";
import moment from "@/utils/moment";

export default {
  mixins: [scrollToMixin, timeMixin],

  components: {
    SearchProfessionals,
    Professionals,
    DatePicker,
    EventsAvailable,
    TimePicker,
    ConfirmPeriodAndPrice
  },

  data() {
    return {
      toDate: moment()
        .subtract(1, "days")
        .toDate(),
      fromDate: moment()
        .add(1, "months")
        .toDate(),
      events: null
    };
  },

  computed: {
    ...mapState("newOrder", [
      "orderToRebook",
      "professionals_available",
      "professional",
      "day",
      "starts_at",
      "ends_at",
      "address",
      "event",
      "price",
      "price_confirmed"
    ])
  },

  methods: {
    ...mapActions("newOrder", ["setEvent", "setStartsAt", "setEndsAt"]),

    sortEvents() {
      this.professional.account.schedule.events.sort((a, b) =>
        a.starts_at > b.starts_at ? 1 : b.starts_at > a.starts_at ? -1 : 0
      );
    },

    getHourOfDate(date) {
      return parseInt(moment(date).format("HH"));
    },

    selectProfessional(professional) {
      this.setProfessional(professional);
      this.scrollTo("#events");
    },

    selectEvent(event) {
      this.setEvent(event);
      this.scrollTo("#time-picker");
    },

    selectStartsAt(startsAt) {
      this.setStartsAt(this.$options.filters.intToTime(startsAt));
    },

    selectEndsAt(endsAt) {
      this.setEndsAt(this.$options.filters.intToTime(endsAt));
      this.scrollTo("#confirm-period-and-price");
    }
  },

  watch: {
    professional(professional) {
      if (professional) this.sortEvents();
    }
  }
};
</script>

<template>
  <div class="mb-40 section" id="PerProfessional">
    <transition name="fade" mode="out-in">
      <search-professionals
        id="search_professionals"
        :class="{ 'passed-on': professional }"
        :address="address"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <professionals
        v-if="professionals_available"
        :searchInput="false"
        :class="{ 'passed-on': professional }"
        @professionalSelected="scrollTo('#events')"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <events-available
        id="events"
        v-if="professional"
        :selectedEvent="event"
        :professional="professional"
        :class="{ 'passed-on': event }"
        @eventSelected="selectEvent"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <time-picker
        id="time-picker"
        title="SELECIONE A HORA INICIAL E FINAL"
        v-if="event"
        :initialHour="getHourOfDate(event.starts_at)"
        :finalHour="getHourOfDate(event.ends_at)"
        :startsAt="parseInt(starts_at)"
        :endsAt="parseInt(ends_at)"
        :class="{ 'passed-on': ends_at }"
        :maxDuration="
          orderToRebook ? orderToRebook.schedule_event.duration / 60 : 8
        "
        @startSelected="selectStartsAt"
        @endSelected="selectEndsAt"
      />
    </transition>

    <transition name="fade" mode="out-in">
      <confirm-period-and-price
        id="confirm-period-and-price"
        v-if="price"
        :class="{ 'passed-on': price_confirmed }"
        @scrollTo="$emit('scrollTo', $event)"
      />
    </transition>
  </div>
</template>

<style scoped>
div {
  transition: all 0.24s ease;
}

.section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.section.passed-on .passed-on {
  opacity: 1;
}

.passed-on {
  opacity: 0.35;
}

.passed-on:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/PerProfessional.vue